import React from 'react';
import { FilterState } from '../types';
import '../styles/Filters.css';

interface FiltersProps {
  filters: FilterState;
  onFiltersChange: (filters: Partial<FilterState>) => void;
}

const Filters: React.FC<FiltersProps> = ({ filters, onFiltersChange }) => {
  return (
    <div className="filters">
      <select
        value={filters.status}
        onChange={(e) => onFiltersChange({ status: e.target.value })}
      >
        <option value="all">All Status</option>
        <option value="formatted">Pending Review</option>
        <option value="doubtful">Doubtful</option>
        <option value="matched">Matched</option>
        <option value="new_hospital">New Hospital</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
      </select>
      
      <input
        type="text"
        placeholder="Search hospital name or address..."
        value={filters.search}
        onChange={(e) => onFiltersChange({ search: e.target.value })}
      />
    </div>
  );
};

export default Filters;